"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const useView = (viewSlice, fetchOptions, options = {}) => {
    const { fetchDocs, fetchParams, } = fetchOptions;
    const { page = 0, squashPages = false, delim = '-', } = options;
    let viewSliceName;
    if (viewSlice instanceof Array) {
        viewSliceName = viewSlice.join(delim);
    }
    else
        viewSliceName = viewSlice;
    const squash = (pages) => pages.slice(0, page + 1).reduce((accum, val) => [...accum, ...val], []);
    const docs = squashPages ?
        squash((0, react_redux_1.useSelector)(state => { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.views) === null || _a === void 0 ? void 0 : _a[viewSliceName]) === null || _b === void 0 ? void 0 : _b.pages; }, react_redux_1.shallowEqual) || []) :
        (0, react_redux_1.useSelector)(state => { var _a, _b, _c; return (_c = (_b = (_a = state === null || state === void 0 ? void 0 : state.views) === null || _a === void 0 ? void 0 : _a[viewSliceName]) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c[page]; }, react_redux_1.shallowEqual) || [];
    const view = (0, react_redux_1.useSelector)(state => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.views) === null || _a === void 0 ? void 0 : _a[viewSliceName]; }, react_redux_1.shallowEqual);
    const adjustViewFields = (_a) => {
        var { pages } = _a, others = __rest(_a, ["pages"]);
        return (Object.assign(Object.assign({}, others), { isReady: true }));
    };
    const dispatch = (0, react_redux_1.useDispatch)();
    const refresh = () => {
        if (fetchDocs)
            dispatch(fetchDocs(viewSliceName, page)(...fetchParams));
    };
    (0, react_1.useEffect)(() => {
        refresh();
    }, fetchParams);
    return [docs, view ? adjustViewFields(view) : { isReady: false, paging: {} }, refresh];
};
exports.default = useView;
